import { Spinner, Text } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import classNames from 'classnames';
import noop from 'lodash/noop';
import type { MouseEvent, ReactNode } from 'react';

import styles from './menuItem.module.scss';

type Props = {
  onClick: (e?: MouseEvent<HTMLLIElement>) => void;
  color?: keyof typeof typography.color;
  content: ReactNode;
  loading?: boolean;
  disabled?: boolean;
};

export function MenuItem({
  onClick,
  content,
  color,
  loading: isLoading,
  disabled: isDisabled,
}: Props): JSX.Element {
  const typographyColor = color && typography.color[color];

  return (
    <li
      role="button"
      aria-disabled={isDisabled}
      className={classNames(styles.root, {
        [styles.disabled]: isDisabled || isLoading,
      })}
      onClick={isDisabled || isLoading ? noop : onClick}
    >
      <Text.Paragraph as="span" color={typographyColor}>
        {content}
      </Text.Paragraph>
      {isLoading && <Spinner size={18} />}
    </li>
  );
}
